/**
 * Workspace Folder Route - View folder contents
 *
 * Shows items within a specific folder.
 * Part of the Data Workspace OS feature set.
 */

import { createFileRoute } from '@tanstack/react-router';

import { WorkspacePage } from '@/features/workspace';
import { workspaceSearchSchema } from '@/features/workspace/utils/workspaceSearchSchema';

export const Route = createFileRoute('/_authenticated/_withWorkspace/workspace/folder/$id')({
  component: WorkspaceFolderPage,
  validateSearch: workspaceSearchSchema,
});

function WorkspaceFolderPage() {
  const { id } = Route.useParams();
  const search = Route.useSearch();

  // Data fetching is handled by useWorkspaceItems via TanStack Query
  // No manual fetch calls needed - queries auto-fetch on mount

  return (
    <WorkspacePage
      folderId={id}
      searchParams={search}
    />
  );
}
